import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";
import { ExternalApiService } from "../services/external-api.service";
import { getPssData } from "../redux/slices/CurrentUserSlice";
import { getOffice } from "../redux/slices/OfficeSlice";
import { useParams } from "react-router-dom";

export interface PssAuthResponse {
  authKey?: string;
  officeId: string;
  officePss: boolean;
  // add other properties if needed
}

const PssNavigate = ({ isAdminPage }: { isAdminPage?: boolean }) => {
  const { id: officeId } = useParams(); // Get office ID from URL
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const [apiData, setApiData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { pssData } = useSelector((state: RootState) => state.currentUser);
  const user = useSelector((state: RootState) => state.currentUser.currentUser);
  const { currentOffice } = useSelector((state: RootState) => state.office);

  const id = searchParams.get("id");
  useEffect(() => {
    if (officeId && !currentOffice) {
      dispatch(getOffice({ officeId }));
    }
  }, [officeId, currentOffice, dispatch]);

  const fetchData = async () => {
    if ((user?.offices && user.offices.length > 0 && user.offices[0]?.officeId) || currentOffice?.officeId) {
      const validId = user?.offices && user.offices.length > 0 ? user.offices[0]?.officeId : currentOffice?.officeId;
      const res = await dispatch(getPssData({ officeId: validId as string }));
      const pssResponse = res.payload as PssAuthResponse | null;

      if (!id || !(res.payload as { authKey?: string })?.authKey) {
        return;
      }
      if (pssResponse && pssResponse.authKey) {
        setLoading(true);
        try {
          const response = await ExternalApiService.fetchDocnoteUrl(id, pssResponse.authKey);

          if (response.success && response.data?.url) {
            setLoading(false);
            window.location.href = response.data.url;
          }
          setApiData(response.data);
        } catch (err) {
          setError(err instanceof Error ? err.message : "An error occurred");
          setLoading(false);
        } finally {
          setLoading(false);
        }
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, pssData?.authKey, currentOffice]);

  // Re-fetch if apiData?.time is available
  useEffect(() => {
    if (apiData?.time) {
      const timeout = setTimeout(() => {
        fetchData();
      }, apiData.time); // apiData.time is in milliseconds

      // Clean up timeout on unmount or when apiData changes
      return () => clearTimeout(timeout);
    }
  }, [apiData?.time]);

  return (
    <div className="p-5">
      <h2 className="font-bold text-xl">PSS Information</h2>
      <div className="text-md font-bold flex items-center justify-center mt-20">
        {!pssData?.authKey ? (
          <div></div>
        ) : loading ? (
          <div className="flex flex-col items-center gap-4">
            <CircularProgress />
            Loading.....
          </div>
        ) : (
          <div>{apiData?.errMsg}</div>
        )}
      </div>
    </div>
  );
};

export default PssNavigate;
